import { Component, OnInit } from '@angular/core';
import { Product } from 'src/app/modals/product.model';
import { ProductService } from 'src/app/components/shared/services/product.service';
import { SharedMethods } from 'src/app/components/shared/services/sharedMethods-service';

@Component({
  selector: 'app-popular-products',
  templateUrl: './popular-products.component.html',
  styleUrls: ['./popular-products.component.sass']
})
export class PopularProductsComponent implements OnInit {

  public products: Product[];
  public product            :   Product = new Product();

   constructor(private productService: ProductService, private sharedMethods: SharedMethods) { }

   ngOnInit() {
     // this.productService.getProducts().subscribe(product => this.products = product);
     if(this.productService.cacheProduct.length === 0) {

      // this.spinner.show();
      this.productService.getProducts().subscribe((product: Product[]) => {

         this.productService.cacheProduct = product;
         // this.products = product

         this.loadVerticalProd();
        // this.spinner.hide();

      });

      } else {

        // this.products = this.productService.cacheProduct;
        this.loadVerticalProd();

     }


   }

   loadVerticalProd() {

    if(this.sharedMethods.cacheSettings === undefined) {

      this.sharedMethods.getSettings().subscribe(setting => {

        // tslint:disable-next-line:max-line-length
        this.products = this.productService.getProductById(this.productService.cacheProduct, this.sharedMethods.cacheSettings.topProduct);

      });

     } else {

        // tslint:disable-next-line:max-line-length
        this.products = this.productService.getProductById(this.productService.cacheProduct, this.sharedMethods.cacheSettings.topProduct);
        // tslint:disable-next-line:max-line-length
    }

  }

  getIdVideo(product) {
    if ( product.linkvideo !== null && product.linkvideo !== undefined ) {
      const tabDate = product.linkvideo.split('/');
      const tab = tabDate[3].split('?');
      return tab[0];
    } else {

      return '';

    }
  }

}
